
import Modal from 'react-bootstrap/Modal';

const ThemeModal = ({children, show, handleHide, title, isFullscreen=false,  size="", centered=false, isPd=true, isHeader=true}) => {
  return (
    <>
      <Modal
        show={show}
        fullscreen={isFullscreen}
        onHide={()=>handleHide(false)}
        keyboard={false}
        size={size}
        centered={centered}
      >
        {
          isHeader &&  <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         {title}
        </Modal.Title>
       </Modal.Header>
        }
      
        <Modal.Body className={isPd ? 'pd-50' : 'pd-0'}>
            {children}
        </Modal.Body>
     
      </Modal>
    </>
  );
}

export default ThemeModal;